// Our main CSS
import '../css/app.css'
import { ModuleManager } from './moduleManager'

// Create and configure module manager
const moduleManager = new ModuleManager()

// Register all modules with their selectors
moduleManager
  .register('#navigation', 'navigation')
  .register('#menus', 'menus')

// Initialize modules
moduleManager.init()

/**
 * Export initialization functions for each admin module.
 *
 * This automatically creates named exports like 'initTimelineSlides' and 'initFaq'
 * that can be imported and called in WordPress admin context.
 *
 * These exports are used by the WordPress admin to initialize modules when
 * specific DOM elements appear in ACF blocks. Each function loads the
 * corresponding module on demand via dynamic import.
 */
Object.keys(moduleManager.adminModules).forEach(name => {
  const modulePath = moduleManager.adminModules[name]
  window[`init${name}`] = () => moduleManager.loadModule(modulePath)
})

// Smooth scroll with offset for anchor links with header offset
document.addEventListener('click', function(e) {
  const header = document.querySelector('header');
  const offset = header ? header.offsetHeight : 0;
  if (e.target.matches('a[href^="#"]')) {
    const id = e.target.getAttribute('href');
    if (id.length > 1 && document.querySelector(id)) {
      e.preventDefault();
      const el = document.querySelector(id);
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }
})